import { Box, Divider, Paper, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import TableSkeleton from "./TableSkeleton";

const ScoreCard = () => (
  <Paper
    variant="outlined"
    sx={{ p: 2, display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}
  >
    <Skeleton variant="circular" animation="wave" width={64} height={64} />
    <Skeleton variant="text" animation="wave" width="55%" sx={{ transform: "none", borderRadius: "4px" }} />
    <Skeleton variant="text" animation="wave" width="35%" sx={{ transform: "none", borderRadius: "4px" }} />
  </Paper>
);

const AccordionBar = ({ width = 90 }: { width?: number }) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{ px: 2, py: 1.5, borderTop: "1px solid #ddd" }}
  >
    <Skeleton variant="text" animation="wave" width={width} height={22} sx={{ transform: "none", borderRadius: "4px" }} />
    <Skeleton variant="circular" animation="wave" width={20} height={20} />
  </Stack>
);

const DashboardSkeleton = () => (
  <Box sx={{ mt: 1 }}>
    {/* Quick Look accordion */}
    <AccordionBar width={90} />
    <Box sx={{ px: 2, pb: 2 }}>
      {/* Score cards */}
      <Grid container spacing={2} mb={2}>
        {[0, 1, 2, 3].map((i) => (
          <Grid key={i} size={3}>
            <ScoreCard />
          </Grid>
        ))}
      </Grid>

      {/* Top / Bottom rated tables */}
      <Grid container spacing={3}>
        <Grid size={6}>
          <Skeleton variant="text" animation="wave" width={130} height={22} sx={{ mb: 1, transform: "none", borderRadius: "4px" }} />
          <TableSkeleton rows={6} columns={5} />
        </Grid>
        <Grid size={6}>
          <Skeleton variant="text" animation="wave" width={145} height={22} sx={{ mb: 1, transform: "none", borderRadius: "4px" }} />
          <TableSkeleton rows={6} columns={5} />
        </Grid>
      </Grid>
    </Box>

    <Divider />

    {/* Real Data accordion */}
    <AccordionBar width={74} />
    <Box sx={{ px: 2, pb: 2 }}>
      <Skeleton
        variant="rectangular"
        animation="wave"
        width="100%"
        height={200}
        sx={{ borderRadius: 1 }}
      />
    </Box>
  </Box>
);

export default DashboardSkeleton;
